import { useActiveLanguage } from "./active-language.ts";
import { translatorFor } from "./catalog.ts";
import type { Catalog, Catalogs, Translate } from "./catalog.ts";

/**
 * The generic hook a module's own `behavior/use-<module>-copy.ts` wraps
 * with its catalogue (`browser-layers`: hooks live in behavior/). Re-renders
 * whenever the active language changes, including right after sign-in.
 */
export function useTranslations<TSource extends Catalog>(catalogs: Catalogs<TSource>): Translate<TSource> {
  const language = useActiveLanguage();
  return translatorFor(catalogs, language);
}
